import React, { useEffect } from "react";
import "./home.css";
import { motion } from "framer-motion";
import { fadeVariants } from "../../Animations/fadeVariants.js";
import Values from "../../Components/Values/Values.jsx";
import SlidingText from "../../Components/SlidingText/SlidingText.jsx";
import SlidingImages from "../../Components/SlidingImages/SlidingImages.jsx";
import Reviews from "../../Components/Reviews/Reviews.jsx";
import Footer from "../../Components/Footer/Footer.jsx";
import Dogs from "../../Components/DogImages/Dogs.jsx";
import WhyChooseUs from "../../Components/WhyChoose/WhyChoose.jsx";
import Navigation from "../../Components/Navigation/Navigation.jsx";
import Navbar from "../../Components/Navbar/Navbar.jsx";
import Write from "../../Components/WriteReview/Write.jsx";
import EbookBuy from "../../Components/Book/Book.jsx";


function Home() {
  useEffect(() => {
    const items = document.querySelectorAll(".fade-in");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    items.forEach((item) => observer.observe(item));

    return () => observer.disconnect();
  }, []);

  return (
    <motion.div
      variants={fadeVariants}
      initial="initial"
      animate="animate"
      exit="exit"
    >
      <Navbar />
      <Navigation />
      <SlidingText />
      <SlidingImages />
      <Reviews />
      <Write />
      <Dogs />
      <WhyChooseUs />
      <Values />
      <EbookBuy />
      <Footer />
    </motion.div>
  );
}

export default Home;
